import Component from '@glimmer/component';
import ReimaginedContributionHistory from 'tio-employee/components/reimagined/production/contribution-history';
import type { ReimaginedContributionHistoryModel } from 'tio-employee/components/reimagined/production/contribution-history';
import type PersonModel from 'tio-common/models/person';

interface SlrDashboardSignature {
  Args: {
    model: { person: PersonModel; reimagined: ReimaginedContributionHistoryModel };
  };
}

export default class SlrDashboardRouteComponent extends Component<SlrDashboardSignature> {
  get reimaginedModel() {
    return this.args.model.reimagined;
  }

  <template><ReimaginedContributionHistory @model={{this.reimaginedModel}} /></template>
}
